export default (hit) => {
  const picSizes = [[332, 222], [679, 453], [440, 293], [360, 240]]

  return `
  <div class="card-photo">
      ${hit.image.singleMedia.publicId !== null
        ? `<picture class="card-photo__pic">
              <source media="(max-width:420px)"
                      data-srcset="https://res.cloudinary.com/dw196z9vy/image/upload/c_fill,f_auto,q_auto,w_${picSizes[3][0]},h_${picSizes[3][1]}/${hit.image.singleMedia.publicId}">
              <source media="(max-width:767px)"
                      data-srcset="https://res.cloudinary.com/dw196z9vy/image/upload/c_fill,f_auto,q_auto,w_${picSizes[2][0]},h_${picSizes[2][1]}/${hit.image.singleMedia.publicId}">
              <source width="${picSizes[1][0]}" height="${picSizes[1][1]}" media="(max-width:1023px)" data-srcset="https://res.cloudinary.com/dw196z9vy/image/upload/c_fill,f_auto,q_auto,w_${picSizes[1][0]},h_${picSizes[1][1]}/${hit.image.singleMedia.publicId}">
              <img class="w-full lazyload" width="${picSizes[0][0]}" height="${picSizes[0][1]}" data-src="https://res.cloudinary.com/dw196z9vy/image/upload/c_fill,f_auto,q_auto,w_${picSizes[0][0]},h_${picSizes[0][1]}/${hit.image.singleMedia.publicId}" alt="${hit.image.singleMedia.alt}"/>
          </picture>`
        : ''
      }

      <div class="card-photo__inner">
          ${hit.expertise !== null
            ? `<div class="flex flex-wrap">
                ${hit.expertise.slice(0, 3).map(expertise => {
                  return `
                    <span class="tag">${expertise}</span>
                  `
                }).join('')
              }
              ${hit.expertise.length > 3
                ? '<span class="tag">+1</span>'
                : ''
              }
              </div>`
            : '<div></div>'
          }
          <button class="cta-arrow text-violet mt-9" js-dynamic-modal="{route: '/ajax/modal/photo', id:'${hit.internalId}', position: 'aside-modal', model: 'photo-modal'}">
              Afficher les détails
              <span class="cta-arrow__circle">
                  <svg width="8" height="8" class="icon--white">
                      <use href="#icon-arrow" xlink:href="#icon-arrow"></use>
                  </svg>
              </span>
          </button>
      </div>

      ${hit.image.singleMedia.publicId !== null
        ? `<a href="https://res.cloudinary.com/dw196z9vy/image/upload/${hit.image.singleMedia.publicId}" target="_blank" rel="nofollow"
            class="card-common__action icon-center">
            <svg width="20" height="20" class="icon--white">
              <use href="#icon-download" xlink:href="#icon-download"></use>
            </svg>
            <span class="sr-only">Télécharger le document</span>
          </a>`
        : ''
      }
  </div>
  `
}
